import { storeToRefs } from 'pinia';
import { useInfo } from '@/store';
import dayjs from 'dayjs';
export function formatTime(unlockTime: number) {
  const { lang } = storeToRefs(useInfo());
  const lowercaseRegion = lang.value?.toLowerCase() || '';
  const format = ['zh-tw', 'ja', 'ko'].includes(lowercaseRegion) ?
    'YYYY/MM/DD HH:mm:ss' :
    'DD/MM/YYYY HH:mm:ss'
  const timestamp = unlockTime * 1000;
  return dayjs(timestamp).format(format);
}
export function formatYearDate(unlockTime: number) {
  const { lang } = storeToRefs(useInfo());
  const lowercaseRegion = lang.value?.toLowerCase() || '';
  const format = ['zh-tw', 'ja', 'ko'].includes(lowercaseRegion) ?
    'YYYY/MM/DD' :
    'DD/MM/YYYY'
  const timestamp = unlockTime * 1000;
  return dayjs(timestamp).format(format);
}
export function formatDate(unlockTime: number) {
  const { lang } = storeToRefs(useInfo());
  const lowercaseRegion = lang.value?.toLowerCase() || '';
  const format = ['zh-tw', 'ja', 'ko'].includes(lowercaseRegion) ?
    'MM/DD' :
    'DD/MM'
  const timestamp = unlockTime * 1000;
  return dayjs(timestamp).format(format);
}